import React from "react";
import Grid from "@material-ui/core/Grid";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import SubtitleLabel from "../../app/Title/SubtitleLabel/SubtitleLabelView";

const GuaranteeInAccount = (props) => {
    return (
        <React.Fragment>
            <div className={props.cssStyle}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <SubtitleLabel header="Garantías en Cuenta " isBold={true}/>
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable
                            value={props.guaranteeList}
                            footerColumnGroup={props.footerColumnGroup}
                            resizableColumns={true}
                            columnResizeMode={"fit"}
                            scrollable={true}
                            scrollHeight="400px"
                        >
                            <Column
                                field="emisora"
                                header="Emisora"
                                filter={true}
                                style={{textAlign: 'left'}}
                                body={props.disableStyleInstrumentTemplate}
                                sortable={true}/>
                            <Column
                                field="aforo"
                                header="% Aforo"
                                body={props.disableStyleInstrumentCapacityTemplate}
                                style={{textAlign: 'right'}}
                                sortable={true}/>
                            <Column
                                field={props.isPrecioVal ? "precioValDescontado" : "precioDescontado"}
                                header="Precio Desc."
                                style={{textAlign: 'right'}}
                                body={props.disableStyleInstrumentPriceTemplate}
                                sortable={true}/>
                            <Column
                                field={props.isPrecioVal ? "precioVal" : "precioMercado"}
                                header="Precio Mercado"
                                style={{textAlign: 'right'}}
                                body={props.disableStyleInstrumentPriceTemplate}
                                sortable={true}/>
                            <Column
                                field="suggested"
                                header="Sugerido"
                                body={props.disableStyleInstrumentNumberTemplate}
                                style={{textAlign: 'right'}}
                                sortable={true}/>
                            <Column
                                field="newTitles"
                                header="Títulos"
                                editor={props.numberEditor}
                                body={props.disableStyleInstrumentNumberTemplate}
                                style={{textAlign: 'right'}}
                                sortable={true}/>
                            <Column
                                field="guaranteeAmount"
                                header="Importe Garantizado"
                                body={props.disableStyleInstrumentAmountTemplate}
                                style={{textAlign: 'right'}}
                                sortable={true}/>
                            <Column
                                field="marketAmount"
                                header="Importe Mercado"
                                body={props.disableStyleInstrumentAmountTemplate}
                                style={{textAlign: 'right'}}
                                sortable={true}/>
                        </DataTable>
                    </Grid>
                </Grid>
            </div>
        </React.Fragment>
    )
};

export default GuaranteeInAccount;